export const API_KEY ="AIzaSyBpCZFyWBBHGiQAfB8Vf7Hzu7a3B86DNNM"

export default  API_KEY; 